import { getCurrentUser } from '../CurrentUser';
import siDefaultWordings from './siDefaultWordings';

let replacements = { ...siDefaultWordings, ...(getCurrentUser() || {}).customReplacements };

export default function replacement(key: ReplacementKey): string {
    return replacements[key]?.replace(/[<>{}]/g, '') ?? key;
}

export function setReplacements(dictionary: { [key: string]: string }): void {
    replacements = { ...replacements, ...dictionary };
}

export type SectionKey =
    | 'general'
    | 'praise'
    | 'meeting'
    | 'survey'
    | 'objective'
    | 'feedbackRequest'
    | 'performanceReview'
    | 'messages'
    | 'login'
    | 'other';

export type Sections = { [sectionKey in SectionKey]: string };

export type SectionItems = [ReplacementKey, ReplacementInfo][];

export type ReplacementInfo = { section: SectionKey; description: string; hideForCustomer?: boolean };

export type ReplacementKey =
    | 'badge'
    | 'badge.big'
    | 'badge.plural'
    | 'badge.plural.big'
    | 'company'
    | 'company.big'
    | 'errorPasswordTooLong'
    | 'errorPasswordTooShort'
    | 'fr.changedMyMind'
    | 'fr.menu.title'
    | 'fr.menu.your'
    | 'fr.menu.unified.title'
    | 'fr.overview.title'
    | 'fr.review.plural'
    | 'fr.review.plural.big'
    | 'fr.review.plural.title'
    | 'fr.review.short'
    | 'fr.review.short.big'
    | 'fr.review.short.plural'
    | 'fr.review.short.plural.big'
    | 'fr.review.singular'
    | 'fr.review.singular.big'
    | 'fr.review.singular.title'
    | 'fr.reviewer'
    | 'fr.reviewer.big'
    | 'fr.reviewer.plural'
    | 'fr.reviewer.plural.big'
    | 'fr.reviewee'
    | 'fr.reviewee.big'
    | 'fr.reviewee.plural'
    | 'fr.reviewee.plural.big'
    | 'fr.review.selfAssessment'
    | 'fr.review.selfAssessment.plural'
    | 'fr.review.selfAssessment.big'
    | 'fr.review.selfAssessment.plural.big'
    | 'fr.short.big'
    | 'fr.singular'
    | 'fr.singular.short'
    | 'fr.singular.title'
    | 'anyfb.name'
    | 'general.hr'
    | 'header.companyName'
    | 'illegalDate'
    | 'login.error.duplicate-loginname'
    | 'login.error.ip-quota-exceeded'
    | 'login.error.locked'
    | 'login.error.quota-exceeded'
    | 'login.error.use-gapps'
    | 'login.error.use-saml'
    | 'login.error.wrong-credentials'
    | 'manager'
    | 'manager.big'
    | 'manager.plural'
    | 'manager.plural.big'
    | 'meeting.name'
    | 'meeting.name.low'
    | 'meeting.name.plural'
    | 'meeting.name.short'
    | 'meeting.name.short.low'
    | 'meeting.name.short.plural'
    | 'meeting.name.short.plural.low'
    | 'messages.export.button'
    | 'messages.a.button'
    | 'messages.a.button.short'
    | 'messages.a.name'
    | 'messages.a.post'
    | 'messages.a.project'
    | 'messages.feedback.button'
    | 'messages.feedback.button.short'
    | 'messages.feedback.name'
    | 'messages.feedback.post'
    | 'messages.feedback.project'
    | 'messages.header'
    | 'messages.ideas.button'
    | 'messages.ideas.button.short'
    | 'messages.ideas.name'
    | 'messages.ideas.post'
    | 'messages.ideas.project'
    | 'messages.menu.title'
    | 'messages.other.button'
    | 'messages.other.button.short'
    | 'messages.other.name'
    | 'messages.other.post'
    | 'messages.other.project'
    | 'messages.plural'
    | 'messages.plural.big'
    | 'messages.pn.button'
    | 'messages.pn.button.short'
    | 'messages.pn.name'
    | 'messages.pn.post'
    | 'messages.pn.project'
    | 'messages.singular'
    | 'messages.singular.big'
    | 'objective.article'
    | 'objective.article.key-result'
    | 'objective.category.singular'
    | 'objective.category.singular.big'
    | 'objective.category.plural'
    | 'objective.category.plural.big'
    | 'objective.create.title.label'
    | 'objective.create.title.placeholder'
    | 'objective.feedbackAbout'
    | 'objective.menu.title'
    | 'objective.plural'
    | 'objective.plural.big'
    | 'objective.plural.key-result'
    | 'objective.plural.title'
    | 'objective.short.plural'
    | 'objective.singular'
    | 'objective.singular.big'
    | 'objective.singular.key-result'
    | 'objective.singular.title'
    | 'objective.title'
    | 'objective.tooltip.click-see-inline'
    | 'objective.tooltip.menu-all'
    | 'objective.tooltip.menu-own'
    | 'objective.tooltip.menu-team'
    | 'objective.tooltip.nudge-employee'
    | 'objective.tooltip.nudge-manager'
    | 'objective.tooltip.restricted-visibility'
    | 'objective.tooltip.view-all'
    | 'objective.type'
    | 'objective.type-label'
    | 'objective.type-label.placeholder'
    | 'objective.parent'
    | 'objective.child.plural'
    | 'pr.assessment'
    | 'pr.assessment.plural'
    | 'pr.managerAssessment'
    | 'pr.managerAssessment.plural'
    | 'pr.menu.title'
    | 'pr.plural'
    | 'pr.plural.medium'
    | 'pr.plural.short'
    | 'pr.plural.title'
    | 'pr.reviewer'
    | 'pr.reviewer.plural'
    | 'pr.reviewerAssessment'
    | 'pr.reviewerAssessment.plural'
    | 'pr.selfAssessment'
    | 'pr.selfAssessment.plural'
    | 'pr.sign'
    | 'pr.sign.big'
    | 'pr.sign.tooltip'
    | 'pr.signed'
    | 'pr.signed.big'
    | 'pr.signing'
    | 'pr.signs'
    | 'pr.singular'
    | 'pr.singular.medium'
    | 'pr.singular.short'
    | 'pr.singular.title'
    | 'pr.title'
    | 'pr.rating'
    | 'pr.rating.short'
    | 'pr.overallRating'
    | 'pr.secondaryOverallRating'
    | 'pr.selfRating'
    | 'pr.preShared.reviewee.saveAndClose'
    | 'pr.preShared.reviewee.share'
    | 'pr.postShared.reviewee.saveAndClose'
    | 'praise.cta'
    | 'praise.email.header'
    | 'praise.header'
    | 'praise.menu.title'
    | 'praise.past'
    | 'praise.progressive'
    | 'praise.plural'
    | 'praise.singular'
    | 'report'
    | 'report.big'
    | 'report.plural'
    | 'report.plural.big'
    | 'RfcCompliantEmailAddressValidator'
    | 'secondaryManager.big'
    | 'surveys.menu'
    | 'surveys.plural'
    | 'surveys.plural.big'
    | 'surveys.short.plural'
    | 'surveys.short.plural.big'
    | 'surveys.short.singular'
    | 'surveys.short.singular.big'
    | 'surveys.singular'
    | 'surveys.singular.big'
    | 'team'
    | 'team.big'
    | 'user.bio'
    | 'valueByManager'
    | 'automations.bot';
